import Loader from 'reusable/mobx-helpers/Loader'
import { notNull } from '@gap/utils/utils'
import { StepperModalFullscreenProps } from './StepperFullscreen'
import { makeAutoObservable } from 'mobx'
import { StepperStep } from '../StepperShared'
import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils'
import { findScrollableAncestor } from 'reusable/utils/utils'

export default class StepperFullscreenStore {
   sp
   loader = new Loader()
   stepStatus: Record<number, boolean> = {}
   private _activeStepIndex = 0

   constructor(sp: StepperModalFullscreenProps & { stepperRootRef: React.RefObject<HTMLElement> }) {
      makeAutoObservable(this)
      this.sp = sp
      sp.storeRef && sp.storeRef.setStore(this)
      this.sp.steps.forEach((_, stepIndex) => {
         this.stepStatus[stepIndex] = sp.stepMustBeMarkedAsDoneBeforeContinue ? false : true
      })

      this.activeStepIndex = 0
   }

   get appBarContainerElement() {
      return findScrollableAncestor(this.sp.stepperRootRef.current)
   }

   get activeStepIndex() {
      return this._activeStepIndex
   }

   get activeStep(): StepperStep | undefined {
      return this.sp.steps[this.activeStepIndex]
   }

   get canWeGoToTheNextStep() {
      return this.stepStatus[this.activeStepIndex] && !this.sp.continueButtonIsLoading
   }

   get showContinueButton() {
      return this.activeStepIndex < this.totalSteps - 1
   }

   get totalSteps() {
      return this.sp.steps.length
   }

   set activeStepIndex(value) {
      this._activeStepIndex = value
      this.appBarContainerElement?.scrollTo({ top: 0 })
   }

   previousStep = () => {
      return this.changeStep(this.activeStepIndex - 1)
   }

   nextStep = () => {
      // Step must be marked as done
      if (this.stepStatus[this.activeStepIndex]) {
         this.changeStep(this.activeStepIndex + 1)
      }
   }

   changeStep = async (newIndex: number) => {
      notNull(this.sp.steps[newIndex])
      await this.sp.onStepChange?.()
      this.activeStepIndex = newIndex
   }

   markStepStatus = (status: boolean) => {
      if (this.sp.stepMustBeMarkedAsDoneBeforeContinue) {
         this.stepStatus[this.activeStepIndex] = status
      }
   }
}

export const { Provider: StepperFullscreenStoreProvider, useProvidedStore: useStepperFullscreenStore } = createStoreContext(StepperFullscreenStore)
